import { useEffect } from "react";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import TrustBar from "@/components/landing/TrustBar";
import Services from "@/components/landing/Services";
import NumbersBand from "@/components/landing/NumbersBand";
import WhyUs from "@/components/landing/WhyUs";
import HowItWorks from "@/components/landing/HowItWorks";
import Calculator from "@/components/landing/Calculator";
import Testimonials from "@/components/landing/Testimonials";
import FAQ from "@/components/landing/FAQ";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";

export default function Landing() {
    useEffect(() => {
        document.title = "QuickFin — Discreet Wealth, Decisive Capital.";
    }, []);

    return (
        <main data-testid="landing-page" className="relative overflow-x-hidden">
            <Nav />
            <Hero />
            <TrustBar />
            <Services />
            <NumbersBand />
            <WhyUs />
            <HowItWorks />
            <Calculator />
            <Testimonials />
            <FAQ />
            <Contact />
            <Footer />
        </main>
    );
}
